export default class StateModel {
	constructor({userName, userLogged}) {
		this.userName = userName;
		this.userLogged = userLogged;
	}
}